import { useEffect } from "react";
import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  useEffect(() => window.scrollTo(0, 0), []);
  return (
    <div className="pt-40 pb-40 max-w-xl mx-auto text-center px-5 min-h-[60vh]" data-testid="payment-cancel">
      <XCircle size={48} className="mx-auto text-muted-foreground" />
      <h1 className="font-display text-5xl tracking-tight mt-8">Plată anulată</h1>
      <p className="text-muted-foreground mt-4">
        Plata nu a fost finalizată. Produsele tale sunt încă în coș — poți încerca din nou oricând.
      </p>
      <div className="flex flex-col sm:flex-row gap-4 justify-center mt-10">
        <Link to="/finalizare" className="bg-ink text-cream px-8 py-4 hover:bg-roast transition-colors text-sm font-semibold">Reia comanda</Link>
        <Link to="/produse" className="border border-line px-8 py-4 hover:border-ink transition-colors text-sm font-semibold">Înapoi la produse</Link>
      </div>
    </div>
  );
}
